import { render } from "./VUEPopupModulazioneGrafici.vue?vue&type=template&id=6a97d71c"
import script from "./VUEPopupModulazioneGrafici.vue?vue&type=script&lang=js"
export * from "./VUEPopupModulazioneGrafici.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__